import {
  faMapMarkerAlt,
  faShoppingBag,
  faMobileAlt,
  faTrash,
  faTimes,
  faEye,
  faSignOutAlt,
  faPhone,
  faUser,
  faArrowLeft,
  faGlobe
} from '@fortawesome/free-solid-svg-icons'
import { faInstagram, faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope } from '@fortawesome/free-regular-svg-icons'

export default {
  faMapMarkerAlt,
  faInstagram,
  faWhatsapp,
  faShoppingBag,
  faEnvelope,
  faMobileAlt,
  faTrash,
  faTimes,
  faEye,
  faSignOutAlt,
  faPhone,
  faUser,
  faArrowLeft,
  faGlobe
}
